import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { RecuperarSenhaCandidato } from '@app/models/sisrh.model';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { SisrhService } from '@app/services/sisrh.service';
import { AppUtil } from '@app/utils/app.util';
import { CpfValidator } from '@app/validators/cpf.validator';
import { ModalService } from '@app/shared/services/modal.service';

@Component({
  templateUrl: './recuperacao-senha.page.html'
})
export class RecuperacaoSenhaPage implements OnInit, AfterViewInit {

  enviando = false;
  exibirAlteracaoEmail = false;
  exibirPerguntasSeguranca = false;
  exibirRecuperacaoSenha = true;
  fgRecuperacaoSenha: FormGroup;
  idCandidato: string;
  mascaraCpf = AppUtil.mascararCpf();

  constructor(
    private autenticacaoService: AutenticacaoService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private sisrhService: SisrhService,
    private router: Router
  ) {

    if (this.autenticacaoService.getValorUsuarioAtualCandidato) {
      this.router.navigate(['/vagas/lista']);
    }

  }

  ngOnInit() {

    this.fgRecuperacaoSenha = this.fb.group({
      cpf: ['', [
        CpfValidator.cpfInvalido,
        Validators.required
      ]]
    });

  }

  ngAfterViewInit() {

    AppUtil.focalizarCampo('idCpf');

  }

  get c() {

    return this.fgRecuperacaoSenha.controls;

  }

  enviar() {

    this.enviando = true;

    if (this.fgRecuperacaoSenha.invalid) {
      return;
    }

    const oRecuperacaoSenha: RecuperarSenhaCandidato = Object.assign({}, this.fgRecuperacaoSenha.value);
    oRecuperacaoSenha.cpf = AppUtil.removerSinais(oRecuperacaoSenha.cpf);

    this.fgRecuperacaoSenha.disable();

    this.sisrhService
      .recuperarSenha(oRecuperacaoSenha)
      .subscribe(
        x => {
          if (x.success) {
            this.modalService.alert(
              's',
              'Sucesso',
              x.message
            ).subscribe(() => this.router.navigate(['/login']));
          } else {
            if (x.data.length) {
              x.data.forEach(y => {
                this.modalService.alert(
                  'a',
                  'Atenção',
                  y.message
                ).subscribe(() => this.ok());
              });
            } else {
              this.abrirPerguntasSeguranca();
            }
          }

        },
        e => {
          this.modalService.alert(
            'e',
            'Erro',
            'Ocorreu um erro. Tente novamente mais tarde.'
          ).subscribe(() => this.ok());
        }
      );

  }

  abrirPerguntasSeguranca() {

    this.exibirPerguntasSeguranca = true;
    this.exibirRecuperacaoSenha = false;

  }

  abrirAlteracaoEmail() {

    this.exibirAlteracaoEmail = true;
    this.exibirPerguntasSeguranca = false;

  }

  eventoPerguntasSeguranca(evento: any) {

    if (evento.ok) {
      if (evento.success) {
        this.idCandidato = evento.data.idCandidato;
        this.abrirAlteracaoEmail();
      } else {
        this.modalService.alert(
          'a',
          'Atenção',
          evento.message
        );
      }
    } else {
      this.modalService.alert(
        'e',
        'Erro',
        'Ocorreu um erro. Tente novamente mais tarde.'
      );
    }

  }

  eventoAlteracaoEmail(evento: any) {

    if (evento.ok) {
      if (evento.success) {
        this.modalService.alert(
          's',
          'Sucesso',
          'Seu e-mail foi alterado com sucesso. Sua senha foi gerada e enviada para o e-mail informado.'
        ).subscribe(() => this.router.navigate(['/login']));
      } else {
        evento.data.forEach(x => {
          this.modalService.alert(
            'a',
            'Atenção',
            x.message
          );
        });
      }
    } else {
      this.modalService.alert(
        'e',
        'Erro',
        'Ocorreu um erro. Tente novamente mais tarde.'
      );
    }

  }

  ok() {

    this.fgRecuperacaoSenha.enable();
    this.enviando = false;
    AppUtil.focalizarCampo('idCpf');

  }

}
